module.exports = __webpack_public_path__ + "static/media/nba.3aba8115.jpeg";